import React,{useEffect, useContext, useState} from 'react'
import GlobelContext from './GlobelContext';

const UserAuth = () =>{
  return useContext(GlobelContext)
}

export default UserAuth;